module.exports = __webpack_public_path__ + "img/logo.d1f17d11.svg";